import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MissionService } from '../../services/mission.service';
import { DocumentReference, updateDoc } from '@angular/fire/firestore';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-mission',
  templateUrl: './mission.component.html',
  styleUrls: ['./mission.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class MissionComponent implements OnInit, OnDestroy {
  @Input() userDocRef: DocumentReference | null = null;
  @Input() userDiamonds = 0;

  currentMission: any = null;
  showMissionResult = false;
  missionResultCorrect = false;
  transitioning: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(private missionService: MissionService) {}

  ngOnInit(): void {
    this.setupMissionSubscriptions();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get missionDiv(): boolean {
    return !!this.currentMission && !this.showMissionResult;
  }

  private setupMissionSubscriptions(): void {
    this.missionService.currentMission$
      .pipe(takeUntil(this.destroy$))
      .subscribe((mission) => {
        this.currentMission = mission;
      });

    this.missionService.missionResult$
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.showMissionResult = result.show;
        this.missionResultCorrect = result.isCorrect;
      });

    this.missionService.fetchAllMission();
  }

  checkAnswer(userAnswer: boolean) {
    this.missionService.checkAnswer(
      userAnswer,
      this.userDocRef,
      (amount: number) => this.updateUserDiamonds(amount)
    );
  }

  private updateUserDiamonds(amount: number): void {
    if (!this.userDocRef) return;

    const newDiamonds = (this.userDiamonds || 0) + amount;

    updateDoc(this.userDocRef, { diamonds: newDiamonds }).catch((error) =>
      console.error('Error updating diamonds:', error)
    );
  }
}
